import { userCenterAPI } from '@/httpService/serviceApi';
import SparkMD5 from 'spark-md5';
export const obsSignUrl = `${userCenterAPI}/open/aliyun/oss/v1/temp/url`;
export const ossSignUrl = `${userCenterAPI}/open/aliyun/oss/v1/temp/url`;
interface genUrlResult {
    success: boolean;
    data: string | undefined | null;
}
export const getOSSUploadSignUrl = async (api: string, bucket_name: string, object_key: string) => {
    try {
        const result = await fetch(api, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                bucket_name,
                object_key,
                method: 'PUT',
                headers: { 'Content-Type': 'multipart/form-data' }
            })
        });

        return result.json();
    } catch (error) {
        console.error(error);
    }
};
export const getDownloadSignUrl = async (bucket_name: string, object_key: string): Promise<genUrlResult> => {
    try {
        const result = await fetch(ossSignUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                bucket_name,
                object_key,
                method: 'GET'
            })
        });
        return result.json().then((res) => {
            const { success, data } = res;
            if (!success) return { success: false, data: null };
            let { result: SignedResult } = data,
                { SignedUrl: url } = SignedResult;
            return { success: true, data: url };
        });
    } catch (error) {
        console.error(error);
        return { success: false, data: JSON.stringify(error) };
    }
};
export const getFileMD5 = (file) => {
    return new Promise((resolve) => {
        if (file && file.size < 2 * 1024 * 1024) {
            const fileReader = new FileReader();
            fileReader.readAsBinaryString(file);
            fileReader.onload = (e: any) => {
                resolve(SparkMD5.hashBinary(e.target.result));
            };
        }
        const sliceLength = 10,
            chunkSize = Math.ceil(file.size / sliceLength),
            fileReader = new FileReader(),
            md5 = new SparkMD5();
        let index = 0,
            loadFile: () => void;
        loadFile = () => {
            const slice = file.slice(index, index + chunkSize);
            fileReader.readAsBinaryString(slice);
        };
        loadFile();
        fileReader.onload = (e: any) => {
            md5.appendBinary(e.target.result);
            if (index < file.size) {
                index += chunkSize;
                loadFile();
            } else {
                resolve(md5.end());
            }
        };
    });
};
export const OSSHeaders = { 'Content-Type': 'multipart/form-data' };
